export default "__VITE_ASSET__CH0Q58ib__";